export { LoadingSpinner, SpinnerIndicator, type LoadingSpinnerSize } from '@/components/feedback/LoadingSpinner';

import { LoadingSpinner, type LoadingSpinnerSize } from '@/components/feedback/LoadingSpinner';

export interface SpinnerProps {
  label?: string;
  size?: LoadingSpinnerSize;
}

/** Full-area loading state — delegates to LoadingSpinner. */
export function Spinner({ label = 'Loading', size = 24 }: SpinnerProps) {
  return <LoadingSpinner size={size} label={label} />;
}
